import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TemplateAccess } from '../../../../models/template-access';
import { AgilityRiskService } from '../../../../providers/agility-risk.service';
import { AgilityRiskFilterService } from '../../../../providers/agility-risk-filter.service';
import { RiskTemplateFilter } from '../../../../models/risk-template-filter';
import { AgilityRiskSpinnerService } from '../../../../providers/agility-risk-spinner.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TemplateAccessStep } from '../../../../agility-risk.enum';

@Component({
  selector: 'lib-access-manager-content',
  templateUrl: './access-manager-content.component.html',
  styleUrls: ['./access-manager-content.component.scss']
})
export class AccessManagerContentComponent implements OnInit {
  @Input() templateAccess: TemplateAccess;
  @Input() contentId: number;
  @Input() liveFilter: Subject<RiskTemplateFilter>;
  @Input() onStepChange: Subject<number>;
  @Output() modelChange: EventEmitter<any> = new EventEmitter();
  pageNumber = 0;
  pageSize = 9999;
  sort: [] = [];
  sourceLists: any = {};
  targetList: any[] = [];
  stepTitle: string;
  filter: any;
  managers: string[] = [];
  summaryTitles = [
    this.translateService.instant('riskTemplates.manageAccess.riskTemplates'),
    this.translateService.instant('riskTemplates.manageAccess.departments'),
    this.translateService.instant('riskTemplates.manageAccess.resources'),
    this.translateService.instant('riskTemplates.manageAccess.sites'),
    this.translateService.instant('riskTemplates.manageAccess.thirdParties')
  ];
  titles = [
    this.translateService.instant('riskTemplates.manageAccess.steps.selectManager'),
    this.translateService.instant('riskTemplates.manageAccess.steps.templateSelection'),
    this.translateService.instant('riskTemplates.manageAccess.steps.assignDepartments'),
    this.translateService.instant('riskTemplates.manageAccess.steps.assignResources'),
    this.translateService.instant('riskTemplates.manageAccess.steps.assignSites'),
    this.translateService.instant('riskTemplates.manageAccess.steps.assignThirdParty'),
    this.translateService.instant('riskTemplates.manageAccess.steps.summary')
  ];
  accessList = [
    'managers',
    'riskTemplates',
    'riskAffectedDepartments',
    'riskAffectedResources',
    'riskAffectedSites',
    'riskAffectedVendors'
  ];
  allLabels = [
    'riskTemplates.manageAccess.allRiskTemplate',
    'riskTemplates.manageAccess.allDepartments',
    'riskTemplates.manageAccess.allResources',
    'riskTemplates.manageAccess.allSites',
    'riskTemplates.manageAccess.allThirdParties'
  ];
  checkboxes = [
    'allTemplates',
    'allDepartments',
    'allResources',
    'allSites',
    'allVendors',

  ];
  templateAccessStep = TemplateAccessStep;

  constructor(
    private agilityService: AgilityRiskService,
    private filterService: AgilityRiskFilterService,
    private spinner: AgilityRiskSpinnerService,
    private translateService: TranslateService) {
  }

  get selectAllToolTip(): string {
    let toolTip: string;
    switch (this.contentId) {
      case TemplateAccessStep.template:
        toolTip = this.translateService.instant('riskTemplates.manageAccess.allRiskTemplateToolTip');
        break;
      case TemplateAccessStep.department:
        toolTip = this.translateService.instant('riskTemplates.manageAccess.allDepartmentsToolTip');
        break;
      case TemplateAccessStep.resource:
        toolTip = this.translateService.instant('riskTemplates.manageAccess.allResourcesToolTip');
        break;
      case TemplateAccessStep.site:
        toolTip = this.translateService.instant('riskTemplates.manageAccess.allSitesToolTip');
        break;
      case TemplateAccessStep.thirdParty:
        toolTip = this.translateService.instant('riskTemplates.manageAccess.allThirdPartiesToolTip');
        break;
    }
    return toolTip;
  }

  ngOnInit() {
    this.agilityService.getManagerAccessList().subscribe({
      next: managers => {
        this.managers = managers.map(m => m.owner.id.toString());
        this.getFilteredList([], 0);
        this.liveFilter.subscribe(filter => {
          this.filter = filter;
          this.getFilteredList(filter);
        });
        this.onStepChange.subscribe(index => {
          this.getFilteredList([], index);
        });
      },
      error: err => {
        console.log(err);
      }
    });
  }

  onModelChange(changes?: any) {
    if (changes) {
      const index = this.checkboxes.findIndex(c => c === changes);
      if (index > -1) {
        if (this.templateAccess[changes] === true) {
          this.templateAccess[this.accessList[index + 1]].length = 0;
        } else {
          this.getFilteredList(this.filter);
        }
      }
    }
    this.modelChange.emit();
  }

  getFilteredList(filterObj?: any, index?: number) {
    const filter = filterObj ? filterObj : [];
    if (index == TemplateAccessStep.summary || this.contentId == TemplateAccessStep.summary) {
      return;
    }
    this.spinner.start();
    const lists = [
      () => {
        if (filter.findIndex(f => f.label === 'Role') === -1) {
          filter.push({
            controlType: 'MULTISELECT',
            filterOption: undefined,
            id: 38,
            label: 'Role',
            value: ['3']
          });
        }
        this.filterService.getFilteredUsers(filter ? filter : [], this.sort, this.pageNumber, this.pageSize, this.managers.filter(m => m !== this.templateAccess.owner?.id)).subscribe({
          next: el => {
            if (this.templateAccess.owner) {
              const owner = el.content.find(m => m.id === this.templateAccess.owner.id);
              const index = el.content.findIndex(m => m.id === this.templateAccess.owner.id);
              if (index > -1) {
                el.content.splice(index, 1);
                el.content.unshift(owner);
              }
            }
            this.sourceLists.managers = el.content;
            this.spinner.stop();
          },
          error: _ => {
            this.spinner.stop();
          }
        });
      },
      () => {
        this.filterService.getFilteredTemplates(filter).subscribe(riskTemplates => {
          this.sourceLists.riskTemplates = riskTemplates.content.filter(t => this.templateAccess.riskTemplates.findIndex(rt => rt.id == t.id) == -1);
          this.spinner.stop();
        });
      },
      () => {
        this.filterService.getFilteredDepartments(filter, this.sort, this.pageNumber, this.pageSize).subscribe(departments => {
          this.sourceLists.riskAffectedDepartments = departments.content.filter(d => this.templateAccess.riskAffectedDepartments.findIndex(rd => rd.id == d.id) == -1);
          this.spinner.stop();
        });
      },
      () => {
        this.filterService.getFilteredResources(filter, this.sort, this.pageNumber, this.pageSize).subscribe(resources => {
          this.sourceLists.riskAffectedResources = resources.content.filter(r => this.templateAccess.riskAffectedResources.findIndex(rs => rs.id == r.id) == -1);
          this.spinner.stop();
        });
      },
      () => {
        this.filterService.getFilteredSites(filter, this.sort, this.pageNumber, this.pageSize).subscribe(sites => {
          this.sourceLists.riskAffectedSites = sites.content.filter(s => this.templateAccess.riskAffectedSites.findIndex(st => st.id == s.id) == -1);
          this.spinner.stop();
        });
      },
      () => {
        this.filterService.getFilteredVendors(filter, this.sort, this.pageNumber, this.pageSize).subscribe(vendors => {
          this.sourceLists.riskAffectedVendors = vendors.content.filter(v => this.templateAccess.riskAffectedVendors.findIndex(vd => vd.id == v.id) == -1);
          this.spinner.stop();
        });
      }
    ];

    return index ? lists[index]() : lists[this.contentId]();
  }
}
